import { isTaxDocumentEmitted } from '@/lib/taxDocument';

function LinkControl({ enabled, unavailable, onClick, children }) {
  if (enabled) {
    return (
      <button type="button" className="card__link" onClick={onClick}>
        {children}
      </button>
    );
  }
  return (
    <span
      className="card__link card__link--disabled"
      title={unavailable}
      aria-disabled="true"
    >
      {children}
    </span>
  );
}

function ButtonControl({ enabled, unavailable, onClick, testId, children }) {
  return (
    <button
      type="button"
      className="t-btn t-btn--secondary t-btn--sm"
      disabled={!enabled}
      onClick={onClick}
      {...(!enabled && {
        title: unavailable,
        'aria-label': unavailable,
      })}
      data-testid={testId}
    >
      {children}
    </button>
  );
}

// Ver + Descargar for a TaxDocument (factura SII or credit note). Always
// visible; enabled only when status === EMITTED. `variant="link"` matches
// Pagos (card__link); `variant="button"` matches ComprobantesPago (t-btn).
export function TaxDocumentActions({
  doc,
  kind = 'factura',
  onView,
  onDownload,
  variant = 'link',
  testId,
}) {
  const emitted = isTaxDocumentEmitted(doc);
  const isNc = kind === 'nc';
  const noun = isNc ? 'Nota de crédito' : 'Factura';
  const unavailable = `${noun} no disponible`;
  const viewLabel = isNc ? 'Ver NC' : 'Ver factura';
  const downloadLabel = isNc ? 'Descargar NC' : 'Descargar factura';

  if (variant === 'button') {
    return (
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <ButtonControl
          enabled={emitted}
          unavailable={unavailable}
          onClick={() => onView(doc)}
          testId={testId ? `${testId}-view` : undefined}
        >
          Ver
        </ButtonControl>
        <ButtonControl
          enabled={emitted}
          unavailable={unavailable}
          onClick={() => onDownload(doc)}
          testId={testId ? `${testId}-download` : undefined}
        >
          Descargar
        </ButtonControl>
      </div>
    );
  }

  return (
    <span className="pg-docs__row">
      <LinkControl
        enabled={emitted}
        unavailable={unavailable}
        onClick={() => onView(doc)}
      >
        {viewLabel}
      </LinkControl>
      <LinkControl
        enabled={emitted}
        unavailable={unavailable}
        onClick={() => onDownload(doc)}
      >
        {downloadLabel}
      </LinkControl>
    </span>
  );
}
